import { useEffect, useState, useCallback } from 'react';
import DropDown from '../components/DropDown';
import API_ROOT from '../config';
import { useFetch } from './Launchpad';

function SelectTenant({ tenant, setTenant }) {
  const [tenants, setTenants] = useState(undefined);
  const { fetchWithAuth } = useFetch();

  const setTenantId = useCallback((id, currentTenants) => {
    const name = id && (currentTenants)?.find(t => t.tenant === id)?.name;
    setTenant({ id, name });
  }, [setTenant]);


  useEffect(() => {

    const fetchTenants = async () => {
      try {
        const url = `${API_ROOT}/tenants`;
        const response = await fetchWithAuth(url);

        if (!response.ok) {
          setTenants([]);
          throw new Error('Unable to list tenants' + response.statusText);
        }
        if (response.status === 204) {
          setTenants([]);
          return [];
        }
        const data = await response.json();
        setTenants(data);
        return data;
      } catch (error) {
        console.error('Error fetching:', error);
      }
    }

    fetchTenants()
      .then(currentTenants => {
        // If the current tenant is not in the list of tenants, reset it
        if (currentTenants && currentTenants.some(t => t.tenant === tenant))
          setTenantId(tenant, currentTenants);
        else
          setTenantId(undefined, undefined)
      });
  }, []);


  if (tenants === undefined) {
    return <div>Loading...</div>;
  }
  if (tenants.length === 0) {
    return <div>No tenants available.</div>;
  }

  const handleError = (error) => {
    console.error('Error:', error);
  }

  return <div>
    <DropDown
      placeholder="Select a tenant"
      options={tenants}
      value={tenant}
      idProperty="tenant"
      onChange={(id)=>setTenantId(id, tenants)}
      onError={handleError} />
  </div>

}

export default SelectTenant;